import {
	whatsappPlatform,
	azurePlatform,
	linePlatform,
	messengerPlatform,
	metabasePlatform,
	restapiPlatform,
	seleniumPlatform,
	telegramPlatform,
	webhooksPlatform,
	workplacePlatform,
	mqttPlatform,
	smartTechPlatform,
	smartOccupancyPlatform,
	googleChatPlatform,
	dormakabaPlatform,
	skylabPlatform,
	nodeRedPlatform,
	swipeTaskPlatform,
	slackPlatform,
	teamsPlatform,
	zapierPlatform,
	monnitPlatform,
	milesightPlatform,
	sensmaxPlatform,
	evercommPlatform,
	viberPlatform,
	bacnetPlatform,
	jtcPlatform,
	proCorePlatform,
	oauth2Platform,
	samlPlatform,
	loriotPlatform,
	uHooPlatform,
	microSoftDynamicsPlatform,
	sapS4Platform,
	lionsBotPlatform,
	hytronPlatform,
	gaussianPlatform,
	metaBotsPlatform,
} from '../utils/images';

const PLATFORMS = [
	{
		title: 'Telegram',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Telegram</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: telegramPlatform,
		status: true,
	},
	{
		title: 'Facebook Messenger',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Messenger</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: messengerPlatform,
		status: true,
	},
	{
		title: 'Facebook Workplace',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Workplace</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: workplacePlatform,
		status: true,
	},
	{
		title: 'Whatsapp',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Whatsapp</p>
      <p>Available as an Add-On with every subscription</p>
      <p>Integration instructions within FacilityBot when feature activated</p>
    `,
		src: whatsappPlatform,
		status: true,
	},
	{
		title: 'Line',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Line</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: linePlatform,
		status: true,
	},
	{
		title: 'Google Chat',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Google Chat</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: googleChatPlatform,
		status: true,
	},
	{
		title: 'Rest APIs',
		category: 'Others',
		description: `
      <p>Build your own integrations using our APIs </p>
      <p>Available with Professional and Plus plans</p>
      <p>Refer to API Documentation</p>
    `,
		src: restapiPlatform,
		status: true,
	},
	{
		title: 'Web Hooks',
		category: 'Others',
		description: `
      <p>Build your own integrations using our Webhooks</p>
      <p>Available with Professional and Plus plans</p>
      <p>Refer to API Documentation</p>
    `,
		src: webhooksPlatform,
		status: true,
	},
	{
		title: 'MetaBase',
		category: 'Data Analytics',
		description: `
      <p>Perform custom data analytics using MetaBase</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for integration instructions</p>
    `,
		src: metabasePlatform,
		status: true,
	},
	{
		title: 'Microsoft Dynamics 365',
		category: 'Enterpise Resource Planning',
		description: `
      <p>Sync Work Orders data with Dynamics</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for integration instructions</p>
    `,
		src: microSoftDynamicsPlatform,
		status: true,
	},
	{
		title: 'SAP S/4 Hana',
		category: 'Enterpise Resource Planning',
		description: `
      <p>Sync Work Orders with SAP S/4 Hana</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for integration instructions</p>
    `,
		src: sapS4Platform,
		status: true,
	},
	{
		title: 'OAuth2 SSO',
		category: 'Security & Authorization',
		description: `
      <p>Allow your users to log in easily via SSO</p>
      <p>Available with Professional and Plus plans</p>
      <p>SSO self-setup available for Microsoft Azure, Okta and other popular platforms</p>
    `,
		src: oauth2Platform,
		status: true,
	},
	{
		title: 'SAML SSO',
		category: 'Security & Authorization',
		description: `
      <p>Allow your users to log in easily via SSO</p>
      <p>Available with Professional and Plus plans</p>
      <p>SSO self-setup available for Microsoft Azure, Okta and other popular platforms</p>
    `,
		src: samlPlatform,
		status: true,
	},
	{
		title: 'Selenium Automation',
		category: 'Others',
		description: `
      <p>Connect to powerful browser automation</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: seleniumPlatform,
		status: true,
	},
	{
		title: 'MQ Telemetry Transport (MQTT)',
		category: 'Others',
		description: `
      <p>Integrate with IOT devices using our MQTT broker</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: mqttPlatform,
		status: true,
	},
	{
		title: 'LorIOT LoRaWAN Network Server',
		category: 'Others',
		description: `
      <p>Integrate with IoT Networks via LorIOT</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: loriotPlatform,
		status: true,
	},
	{
		title: 'CST Smart Toilet System',
		category: 'Sensors',
		description: `
      <p>Pre-integrated people counters, ammonia sensors and more</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: smartTechPlatform,
		status: true,
	},
	{
		title: 'CST Smart Occupancy Sensor',
		category: 'Sensors',
		description: `
      <p>Pre-integrated mmWave (non-video) Occupancy Sensor. Great for social distancing monitoring Privacy protected</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: smartOccupancyPlatform,
		status: true,
	},
	{
		title: 'dormakaba exivo',
		category: 'Others',
		description: `
      <p>Allow visitors to open doors and turnstiles without reporting to reception</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: dormakabaPlatform,
		status: true,
	},
	{
		title: 'Skylab IGX IoT gateway',
		category: 'Others',
		description: `
      <p>An advanced multi-protocol aware middleware that allows FacilityBot to be integrated with almost any kind of IoT data source and destination</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: skylabPlatform,
		status: true,
	},
	{
		title: 'Node-RED',
		category: 'Sensors',
		description: `
      <p>Use a low-code, browser-based, graphical interface to link sensors of all kinds to FacilityBot's MQTT broker</p>
      <p>Available with Professional and Plus plans</p>
      <p>View setup guide <a href='https://blog.facilitybot.co/knowledge-base/integrations/setting-up-node-red-to-send-mqtt-data-to-facilitybot/' target='_blank' rel='noreferrer'>here</a></p>
    `,
		src: nodeRedPlatform,
		status: true,
	},
	{
		title: 'Swipetask Smart-Bins',
		category: 'Sensors',
		description: `
      <p>Pre-integrated smart bins with sensors that automatically alert a Responder when full</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for integration instructions</p>
    `,
		src: swipeTaskPlatform,
		status: true,
	},
	{
		title: 'Slack',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Slack</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: slackPlatform,
		status: true,
	},
	{
		title: 'Teams',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Teams</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: teamsPlatform,
		status: true,
	},
	{
		title: 'Zapier',
		category: 'Others',
		description: `
      <p>Connect FacilityBot with over 5000 other apps including email, slack, CRMs, ERPs via Zapier - no code required</p>
      <p>Available with Professional and Plus plans</p>
      <p>Click <a href='https://zapier.com/apps/facilitybot/integrations' target='_blank' rel='noreferrer'>here</a> for more info</p>
    `,
		src: zapierPlatform,
		status: true,
	},
	{
		title: 'Monnit',
		category: 'Sensors',
		description: `
      <p>Over 80 sensor types including temperature, humidity, motion, occupancy, current, light, vibration, water, pressure and button press sensors</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: monnitPlatform,
		status: true,
	},
	{
		title: 'SensMax',
		homepage: 'https://sensmax.eu/',
		category: 'Sensors',
		description: `
      <p>Radar-based real-time people counting sensors for retail stores, libraries, public premises, outdoor parks and toilets</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: sensmaxPlatform,
		status: true,
	},
	{
		title: 'Milesight',
		homepage: 'https://www.milesight-iot.com/',
		category: 'Sensors',
		description: `
      <p>Indoor Air Quality and AI Workplace Sensors</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: milesightPlatform,
		status: true,
	},
	{
		title: 'Evercomm',
		homepage: 'https://www.evercomm.com.sg/',
		category: 'Sensors',
		description: `
      <p>Advanced energy, water quality, air quality, and chiller analytics supported by machine learning and a range of IoT sensors that can trigger tickets in FacilityBot</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: evercommPlatform,
		status: true,
	},
	{
		title: 'uHoo',
		homepage: 'https://getuhoo.com/',
		category: 'Sensors',
		description: `
      <p>Comprehensive Air Sensor that Provides Allergen and Toxin Alerts</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: uHooPlatform,
		status: true,
	},
	{
		title: 'LionsBot',
		homepage: 'https://www.lionsbot.com/',
		category: 'Robots',
		description: `
      <p>Smart cleaning robot solutions</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: lionsBotPlatform,
		status: true,
	},
	{
		title: 'Hytron',
		category: 'Robots',
		description: `
      <p>AI-Powered Cleaning Robots</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: hytronPlatform,
		status: true,
	},
	{
		title: 'Gaussian',
		category: 'Robots',
		description: `
      <p>Smart Cleaning Robots</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: gaussianPlatform,
		status: true,
	},
	{
		title: 'MetaBots',
		category: 'Robots',
		description: `
      <p>Smart Cleaning Robots</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: metaBotsPlatform,
		status: true,
	},
	{
		title: 'Viber',
		category: 'Messaging Channels',
		description: `
      <p>Chat with FacilityBot through Viber</p>
      <p>Available with every subscription</p>
      <p>Integration instructions within FacilityBot</p>
    `,
		src: viberPlatform,
		status: true,
	},
	{
		title: 'BACNet',
		category: 'Others',
		description: `
      <p>Use FacilityBot's proprietary BACNet gateway to connect to BMS systems</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: bacnetPlatform,
		status: true,
	},
	{
		title: 'Jurong Town Corporation',
		category: 'Others',
		description: `
      <p>Easily Connect to Jurong Town Coroporation's Job Management Module system</p>
      <p>Available with Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: jtcPlatform,
		status: true,
	},
	{
		title: 'Procore',
		category: 'Others',
		description: `
      <p>Transition seamlessly from construction management to facilities management</p>
      <p>Available with Professional and Plus plans</p>
      <p>Contact us for Integration Instructions</p>
    `,
		src: proCorePlatform,
		status: true,
	},
];

const CATEGORIES = PLATFORMS.map((item) => item.category);
const countCategory = (selected) => {
	return CATEGORIES.filter((category) => category == selected).length || CATEGORIES.length;
};

const uniqueCategory = (unique, index, array) => array.indexOf(unique) == index;
const PLATFORMS_CATEGORIES = CATEGORIES.filter(uniqueCategory);

PLATFORMS_CATEGORIES.push('All');
PLATFORMS_CATEGORIES.sort();

export { PLATFORMS, PLATFORMS_CATEGORIES, countCategory };
